import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppShell } from "@/components/AppShell";
import HomePage from "@/pages/HomePage";
import GeneratorPage from "@/pages/GeneratorPage";
import IdeaPromptPage from "@/pages/IdeaPromptPage";
import TemplatesPage from "@/pages/TemplatesPage";
import ImproverPage from "@/pages/ImproverPage";
import GuidePage from "@/pages/GuidePage";
import LibraryPage from "@/pages/LibraryPage";
import ShortVideoPromptPage from "@/pages/ShortVideoPromptPage";
import TemplateBuilderPage from "@/pages/TemplateBuilderPage";

function App() {
  return (
    <BrowserRouter>
      <AppShell>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/luo-promptti" element={<GeneratorPage />} />
          <Route path="/ideasta-promptiksi" element={<IdeaPromptPage />} />
          <Route path="/lyhytvideo" element={<ShortVideoPromptPage />} />
          <Route path="/pohjat" element={<TemplatesPage />} />
          <Route path="/pohjat/:templateId" element={<TemplateBuilderPage />} />
          <Route path="/paranna" element={<ImproverPage />} />
          <Route path="/kuvapromptti" element={<Navigate to="/pohjat/ai-kuvapromptit-master" replace />} />
          <Route path="/videopromptti" element={<Navigate to="/pohjat/ai-videopromptit-master" replace />} />
          <Route path="/rakenneopas" element={<GuidePage />} />
          <Route path="/kirjasto" element={<LibraryPage />} />
        </Routes>
      </AppShell>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}

export default App;